// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1bKg1","item":"_2QedU"};